import { type Topic } from "#/components/exam-results/views/type-2/overall";
import { type SingleStudentExamResult } from "#/services/rest/gwt/exam-results/views/type-2/single-user.types";
import { useBreakLG } from "@monta/design-system";
import clsx from "clsx";
import MultiLessonCards from "./Cards";
import styles from "./styles.module.scss";
import MultiLessonTable from "./Table";

type Props = {
  participantNo: number;
  data: SingleStudentExamResult[];
  onDataTypeChange: () => void;
  dataType: Topic;
};

const MultiLesson = ({
  participantNo,
  data,
  dataType,
  onDataTypeChange
}: Props) => {
  const isDesktop = useBreakLG();

  return (
    <div className={styles["multiLesson"]}>
      <div className={styles["multiLesson__header"]}>
        <h2 className={styles["multiLesson__header-title"]}>
          {data[0].examName}
        </h2>

        <div className={styles["toggle"]}>
          <div
            className={clsx(
              styles["toggle__slider"],
              dataType === "topic"
                ? styles["toggle__slider--right"]
                : styles["toggle__slider--left"]
            )}
          />
          <button
            onClick={onDataTypeChange}
            className={clsx(
              styles["toggle__option"],
              dataType === "topic" ? styles["toggle__option--active"] : ""
            )}
          >
            گروه درسی
          </button>
          <button
            onClick={onDataTypeChange}
            className={clsx(
              styles["toggle__option"],
              dataType === "book" ? styles["toggle__option--active"] : ""
            )}
          >
            کتاب
          </button>
        </div>
      </div>

      {isDesktop ? (
        <MultiLessonTable
          participantNo={participantNo}
          activeCategory={dataType}
          data={data}
        />
      ) : (
        <MultiLessonCards participantNo={participantNo} data={data} />
      )}
    </div>
  );
};

export default MultiLesson;
